import { TierIiReportKind } from "generated-graphql/graphql";

export function formatReportKindForDrillDown(
  reportKind: TierIiReportKind | undefined
): string | undefined {
  if (!reportKind) return undefined;
  return reportKind === TierIiReportKind.Annual ? "Annual|null" : reportKind;
}
